export default function SILBreakdown({ signals, composite, risk }: { signals: any[]; composite: number; risk?: number }) {
  if (!signals || signals.length === 0) return null;

  return (
    <div>
      <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-dimmer)', marginBottom: 8, letterSpacing: 1 }}>
        SIL CONFIDENCE BREAKDOWN
      </div>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--bg-border)', borderRadius: 10, padding: 14, marginBottom: 16 }}>
        {/* Composite score header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, paddingBottom: 10, borderBottom: '1px solid var(--bg-border)' }}>
          <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-dim)' }}>Composite Score</span>
          <span className="mono" style={{ fontSize: 18, fontWeight: 600, color: composite >= 0.85 ? 'var(--accent-good)' : composite >= 0.6 ? 'var(--accent-warning)' : 'var(--accent-critical)' }}>
            {(composite * 100).toFixed(0)}%
          </span>
        </div>

        {/* Signal bars */}
        {signals.map((sig: any, i: number) => {
          const score = sig.score || sig.avg_score || 0;
          const barColor = score >= 0.8 ? 'var(--accent-good)' : score >= 0.6 ? 'var(--accent-warning)' : 'var(--accent-critical)';
          return (
            <div key={i} style={{ marginBottom: 6 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                <span style={{ fontSize: 9, color: 'var(--text-dim)', fontWeight: 600, textTransform: 'uppercase' }}>
                  {(sig.signal_type || '').replace(/_/g, ' ')}
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span className="mono" style={{ fontSize: 9, color: barColor, fontWeight: 700 }}>
                    {(score * 100).toFixed(0)}%
                  </span>
                  {sig.weight && (
                    <span style={{ fontSize: 8, color: 'var(--text-dimmer)' }}>x{sig.weight}</span>
                  )}
                </div>
              </div>
              <div style={{ height: 5, background: 'rgba(0,0,0,0.05)', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{ width: `${score * 100}%`, height: '100%', background: barColor, borderRadius: 3, transition: 'width 0.3s' }} />
              </div>
            </div>
          );
        })}

        {/* Risk score if provided */}
        {risk != null && (
          <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid var(--bg-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 10, fontWeight: 600, color: 'var(--text-dim)' }}>Risk Score</span>
            <span className="mono" style={{ fontSize: 14, fontWeight: 600, color: risk < 25 ? 'var(--accent-good)' : risk < 50 ? 'var(--accent-warning)' : 'var(--accent-critical)' }}>
              {risk.toFixed(0)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
